<template>
  <div>
    <md-switch v-model="activeItem" class="md-primary catalog__switch"></md-switch>

    <img :src="item.icon" alt="">
    <p class="md-subheading catalog__item-title" v-html="item.name"></p>
    <div>
      <span class="md-body-1">{{item.quantity}} | </span>
      <span class="md-body-2">CHF {{item.price.toFixed(2)}}</span>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    name: "CatalogItem",
    data() {
      return {
        activeItem: null,
        initalState: true
      }
    },
    props: ['item'],
    watch: {
      item: {
        deep: true,
        handler: function() {
          this.setActiveState()
        }
      },
      activeItem: function(o, n) {
        if(!this.initalState && n !== null ) {
          let data = {
            id: this.item.id,
            state: this.activeItem
          }
          this.updateItem(data)
        }
      }
    },
    mounted() {
      this.setActiveState()
    },
    methods: {
      ...mapActions('catalog', [
        'updateItem'
      ]),
      setActiveState: function() {
        this.activeItem = (this.item.active === 1)
        this.initalState = false
      }
    }
  }
</script>